import script from "./leftMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./leftMenu.vue?vue&type=script&lang=ts&setup=true"

import "./leftMenu.vue?vue&type=style&index=0&id=a63fffe0&lang=scss&scoped=true"

import exportComponent from "E:\\phpstudy_pro\\WebWWW\\client-dev\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a63fffe0"]])

export default __exports__